import React from "react";
import paypalIcon from "@/public/fallbacks/paypal-new.svg";
import { useTemplateStore } from "@/zustand/templateStore";
import s from "@/components/Buttons/ExpressCheckoutButtons.module.scss";
import bs from "@/components/Buttons/PaypalButton.module.scss";

const paypalBtnStyles = window?.post_template?.checkout_v6_global_components;

const PaypalButton = ({ height, margin, modifications, submitFunc, trigger, showTermsBox, control }) => {
  const { handlePaymentMethodChange } = useTemplateStore();
  // const paypalUpper = window.post_template?.checkout_v6_form?.tr_checkout_v6_paypal_upper;
  // const paypalBottom = window.post_template?.checkout_v6_form?.tr_checkout_v6_paypal_bottom;

  const paypalStyles = {
    "--paypalBackground": paypalBtnStyles.checkout_v6_components_paypalBackground,
    "--paypalHover": paypalBtnStyles.checkout_v6_components_paypalBackgroundHover,
    "--paypalShadow": paypalBtnStyles.checkout_v6_components_paypalShadowColor,
    "--paypalShadowHover": paypalBtnStyles.checkout_v6_components_paypalShadowColorHover,
    "--paypalTextColor": paypalBtnStyles.checkout_v6_components_paypalTextColor,
    marginTop: margin,
  };

  const handlePaypalSubmit = async (e) => {
    e.preventDefault();

    handlePaymentMethodChange("paypal");

    const isChecked = await trigger("policy");

    if (!isChecked && showTermsBox) {
      // Scroll to the policy checkbox
      const policyInput = document.getElementsByName("policy")[0];
      if (policyInput) {
        policyInput.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        return;
      }

      setTimeout(() => {
        if (control) {
          control.unregister("policy");
          control.register("policy");
        }
      }, 3000);
    }

    submitFunc();
  };

  return (
    <div className={s["paypal-container"]}>
      <button
        onClick={handlePaypalSubmit}
        style={paypalStyles}
        formNoValidate
        type="button"
        className={`${bs["submitPaypal"]} ${bs["submitPaypal--active"]} ${
          modifications?.expressButton ? bs["expressButton"] : ""
        }`}
      >
        <img
          src={paypalIcon}
          style={{ maxHeight: `${height}px` }}
          className={s["submitPaypal__paypalLogo"]}
          alt="PayPal"
        />
      </button>
    </div>
  );
};

export default PaypalButton;
